import 'owl.carousel/dist/owl.carousel.js';
import 'owl.carousel/dist/assets/owl.carousel.css';

jQuery(document).ready(function () {
	function genOwlNavHeight(event) {
		var $target = jQuery(event.target);
		var width = $target.find('.owl-item').first().width();
		$target.find('.owl-prev, .owl-next').css('height', width);
	}
	var $owl = jQuery('.carouselwrap .owl-carousel');
	$owl.owlCarousel({
		items: 3,
		dots: true,
		loop: true,
		rewind: false,
		nav: true,
		margin: 20,
		dots: true,
		dotsEach: true,
		navText: [
			'<svg class="svg-inline--fa fa-chevron-left fa-w-10" aria-hidden="true" data-prefix="fa" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg=""><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg>',
			'<svg class="svg-inline--fa fa-chevron-right fa-w-10" aria-hidden="true" data-prefix="fa" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg=""><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>',
		],
		onInitialized: genOwlNavHeight,
		onRefreshed: genOwlNavHeight,
		responsive: {
			0: { items: 2 },
			670: { items: 3 },
		},
	});
	$owl.on('drag.owl.carousel', function (event) {
		document.ontouchmove = function (e) {
			e.preventDefault();
		};
	});
	$owl.on('dragged.owl.carousel', function (event) {
		document.ontouchmove = function (e) {
			return true;
		};
	});
});
